module.exports = __webpack_public_path__ + "img/f9d07fe.png";